import { render, staticRenderFns } from "./RelatedPerformances.vue?vue&type=template&id=6d27cb16&"
import script from "./RelatedPerformances.vue?vue&type=script&lang=ts&"
export * from "./RelatedPerformances.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedPerformances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlockHorizontalList: require('/tmp/build_dc55b0b5/src/components/block/HorizontalList.vue').default})
